import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { Typography } from '@jouzen/ecom-components/v3/Typography';

import RichText from '@/app/components/RichText';

export const MetabolicHealthDisclaimer = () => {
  return (
    <div
      data-cy="metabolic-health-disclaimer"
      className="bg-mustard-350 py-10 text-sandstone-100"
    >
      <LayoutGrid>
        <GridItem
          className="flex flex-col gap-5 border-y border-white/20 py-10 text-sandstone-100"
          colEnd={{ sm: 'main', md: 'main', lg: 24 }}
          colStart={{ sm: 'main', md: 'main', lg: 2 }}
        >
          <Typography className="text-sm text-sandstone-100">
            <RichText messageKey="dexcom_trademarks_disclaimer" />
          </Typography>
        </GridItem>
      </LayoutGrid>
    </div>
  );
};
